import { render, staticRenderFns } from "./headerMain.vue?vue&type=template&id=0fb88371&scoped=true&"
import script from "./headerMain.vue?vue&type=script&lang=js&"
export * from "./headerMain.vue?vue&type=script&lang=js&"
import style0 from "./headerMain.vue?vue&type=style&index=0&id=0fb88371&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb88371",
  null
  
)

export default component.exports